<template>
  <div class="container">
    <div class="box_main">
      <iframe
        id="iframeContain"
        name="iframeContain"
        seamless
        scrolling="no"
        :src="'https://www.hidisp.cn/account/login?service=https%3A%2F%2Fwww.iledcloud.cn%2Fhome'"
        style="width:100%;height:100%;overflow: hidden;"
      ></iframe>
     <!-- :src="'https://www.hidisp.cn/account/login?v='+Math.round(Math.random()*10000)" -->
     <!-- :src="'../../../static/message/login.html?u='+$store.state.user.account.information_account+'&p='+$store.state.user.account.information_password" -->
      <div class="message_user" v-if="message_vibilty">
          <div class="message_user_box">
            <div>账号：<span>{{$store.state.user.account.information_account}}</span></div>
            <div>密码：<span>{{$store.state.user.account.information_password}}</span></div>
            <!-- <div class="close_mess" @click="message_vibilty = false"><i class="el-icon-close"></i></div> -->
            <div class="message_link" @click="openNew">去登录信息发布平台</div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      title: '',
      message_vibilty:true
    }
  },
  methods: {
    openNew(){
      window.open('https://www.hidisp.cn/account/login?service=https%3A%2F%2Fwww.iledcloud.cn%2Fhome', '_blank');
    }
  }
}
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  height:100%;
  background:url('../../assets/datacount.png') no-repeat;
  background-size: cover;
  
}

.box_main{
  position: absolute;
  top:-52px;
  left:0;
  right:0;
  bottom:0;
  overflow: hidden;
}

#iframeContain{
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin:0;
}
.message_user{
  width:430px;
  height:350px;
  position:absolute;
  background: #fff;
  left:50%;
  top:180px;
  padding: 24px 35px 80px;
  margin-left: 160px;
  border-radius: 10px;
  box-sizing:border-box;
  .message_user_box{
    width:100%;
    height:100%;
    position: relative;
    color:#999;
    font-size:18px;
    line-height: 2;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .close_mess{
      position:absolute;
      display: flex;
      align-items: center;
      justify-content: center; /* 水平均匀分布 */
      width:24px;
      height:24px;
      background: #3b8cff;
      border-radius: 24px;
      right:-20px;
      top:-10px;
      color:#fff;
      cursor: pointer;
    }
    span{
      color:#3b8cff;
    }
    .message_link{
      color:#3b8cff;
      cursor: pointer;
      margin-top: 30px;
      text-align: center;
    }
  }
}
</style>